export default __webpack_public_path__ + "static/media/rampaginghorde.03e7250f.png";